import { useMemo } from 'react';
import type { PopoverOrigin } from '@mui/material/Popover';

import type { DragDirection } from './types';

export const usePopoverPosition = (direction: DragDirection) => {
  const anchorOrigin = useMemo<PopoverOrigin>(
    () =>
      direction === 'horizontal'
        ? { vertical: 'bottom', horizontal: 'right' }
        : { vertical: 'top', horizontal: 'left' },
    [direction]
  );
  const transformOrigin = useMemo<PopoverOrigin>(
    () =>
      direction === 'horizontal'
        ? { vertical: 'bottom', horizontal: 'left' }
        : { vertical: 'bottom', horizontal: 'left' },
    [direction]
  );

  return { anchorOrigin, transformOrigin };
};
